var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6447 1.87384C16.4492 1.13623 15.8733 0.555387 15.1418 0.358259C13.8161 9.53674e-07 8.5 0 8.5 0C8.5 0 3.18395 9.53674e-07 1.85821 0.358259C1.12679 0.555387 0.550719 1.13623 0.355235 1.87384C0 3.21071 0 6 0 6C0 6 0 8.78925 0.355235 10.1262C0.550719 10.8638 1.12679 11.4446 1.85821 11.6418C3.18395 12 8.5 12 8.5 12C8.5 12 13.8161 12 15.1418 11.6418C15.8733 11.4446 16.4492 10.8638 16.6447 10.1262C17 8.78925 17 6 17 6C17 6 17 3.21071 16.6447 1.87384Z",
    fill: "#D9DBE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76135 8.53247L11.2045 6.00013L6.76135 3.46755V8.53247Z",
    fill: "#8D9299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.16a541fdd907d7cf34e7fe5ce5c1ac9a.svg";
export { ForwardRef as ReactComponent };